export enum WorkflowStageDataStatus {
    NotStarted = 1,
    InProgress,
    Complete,
    Rejected
}